export function redirect(href) {
    if (href) {
        document.body.classList.add('searching');
        window.location = href;
    }
};
